import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { helpUrl } from "configs/config";

const HelpLink = ({url, style, size="24px", ...props}) => {
 return(<div
    style={style}
    {...props}
  >
    <a
      href={helpUrl + url}
      target="Hilfe"
      title="Hilfe öffnen"
      onClick={(e) => e.stopPropagation()}
    >
      <FontAwesomeIcon
        style={{ width: size, height: size }}
        icon={faQuestionCircle}
        color="grey"
      />
    </a>
  </div>)
}

export default HelpLink